import { render, staticRenderFns } from "./edit_other_attrs.vue?vue&type=template&id=88bcb0a4&scoped=true"
import script from "./edit_other_attrs.vue?vue&type=script&lang=js"
export * from "./edit_other_attrs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bcb0a4",
  null
  
)

export default component.exports